import { SurveyInitialState } from '@r1-frontend/survey/context/reducer/initialState';
import { SurveyItem } from '@r1-frontend/survey/context/surveys';

const getCommonSurvey = (state: SurveyInitialState): SurveyItem | undefined => {
    return state.survey.find(srv => srv.type === 'common');
};

export default getCommonSurvey;
